import get from 'lodash/get';
import set from 'lodash/set';
import { produce } from 'immer';
import { useContext } from 'react';

import FormContext from 'src/presentation/contexts/FormContext';
import { IvrEditorContext } from '../IvrEditor';

export default function useSaveTemporarySplit(attr, defaultOffId, newNode, onSelectNode) {
  const { onBlur, updateState, workingState } = useContext(FormContext);
  const { setIsSaveInProgress } = useContext(IvrEditorContext);

  return nodeSchedules => {
    setIsSaveInProgress(true);

    const item = get(workingState, attr);
    const newScheduleNode = { ...item, nodeSchedules, defaultOffId };

    const currentState = produce(workingState, (draftState: any) => {
      if (newNode) {
        const nodeId = get(newNode, 'ivrNode.id', '');
        draftState.nodesMap[nodeId] = newNode;
      }

      set(draftState, attr, newScheduleNode);
    });

    updateState(set({}, attr, newScheduleNode));
    onBlur && onBlur({ currentState });

    if (newNode) {
      onSelectNode && onSelectNode(get(newNode, 'ivrNode.id'));
    }
  };
}
